module.exports = __webpack_public_path__ + "static/media/default.8225dc65.jpg";